import React from "react";
import { C } from "../constants/baziData";

function NarrativeCard({ title, subtitle, text, highlight }) {
  if (!text) return null;
  return (
    <div style={{
      borderLeft: "3px solid rgba(212,175,55,.5)",
      padding: "14px 16px",
      background: highlight ? "rgba(212,175,55,.05)" : "white",
      borderRadius: "0 8px 8px 0",
      border: "1px solid rgba(212,175,55,.15)",
      borderLeft: "3px solid rgba(212,175,55,.5)",
    }}>
      <div style={{
        fontFamily: "sans-serif", fontSize: 10, letterSpacing: ".12em",
        color: "#A0813C", textTransform: "uppercase", marginBottom: 4,
        fontWeight: 700,
      }}>{title}</div>
      {subtitle && (
        <div style={{ fontSize: 11, color: "#9A8070", marginBottom: 8 }}>{subtitle}</div>
      )}
      <div style={{ fontSize: 13, color: "#333", lineHeight: 1.8 }}>{text}</div>
    </div>
  );
}

function StemBranchRow({ label, icon, items }) {
  if (!items || Object.keys(items).length === 0) return null;
  return (
    <div style={{
      background: "white", border: "1px solid #EDE4D0",
      borderRadius: 8, padding: "14px 16px",
    }}>
      <div style={{
        display: "flex", alignItems: "center", gap: 6,
        marginBottom: 10,
        fontFamily: "sans-serif", fontSize: 11,
        color: "#A0813C", fontWeight: 700, letterSpacing: ".08em",
      }}>
        <span>{icon}</span>{label}
      </div>
      <div style={{
        display: "grid",
        gridTemplateColumns: "repeat(2, 1fr)",
        gap: 8,
      }}>
        {Object.entries(items).map(([key, val]) => (
          <div key={key} style={{
            padding: "8px 10px",
            background: "rgba(212,175,55,.04)",
            borderRadius: 6, border: "1px solid rgba(212,175,55,.12)",
          }}>
            <div style={{
              fontSize: 10, color: "#9A8070",
              fontFamily: "sans-serif", marginBottom: 3,
            }}>{key}</div>
            <div style={{ fontSize: 12, color: "#333", lineHeight: 1.6 }}>{val}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

function LayerAnalysis({ layer_analysis, stem_branch_division, lang }) {
  if (!layer_analysis && !stem_branch_division) return null;

  const la = layer_analysis || {};
  const sbd = stem_branch_division || {};

  const cards = [
    {
      title: lang === "zh" ? "流年 → 大运" : "Annual → Cycle",
      subtitle: lang === "zh" ? "流年与当前大运的相互作用" : "Annual fortune interacting with luck cycle",
      text: la.liunian_to_dayun,
      highlight: la.direct_hit,
    },
    {
      title: lang === "zh" ? "合力 → 原局" : "Combined → Natal",
      subtitle: lang === "zh" ? "大运+流年合力对原局的影响" : "Combined cycle-annual effect on natal chart",
      text: la.combined_to_natal,
      highlight: false,
    },
    {
      title: lang === "zh" ? "直作用" : "Direct Impact",
      subtitle: lang === "zh" ? "流年对日主的直接引动" : "Annual fortune's direct effect on day master",
      text: la.direct_desc,
      highlight: la.direct_hit,
    },
  ].filter(c => c.text);

  return (
    <div>
      {cards.length > 0 && (
        <div style={{
          display: "grid",
          gridTemplateColumns: `repeat(${Math.min(cards.length, 3)}, 1fr)`,
          gap: 12,
          marginBottom: 16,
        }}>
          {cards.map((card, i) => (
            <NarrativeCard key={i} {...card} />
          ))}
        </div>
      )}

      {(sbd.external || sbd.internal) && (
        <div style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: 12,
        }}>
          {sbd.external && (
            <StemBranchRow
              icon="☀"
              label={lang === "zh" ? "天干 · 外事领域" : "Stem · External Affairs"}
              items={sbd.external}
            />
          )}
          {sbd.internal && (
            <StemBranchRow
              icon="🌙"
              label={lang === "zh" ? "地支 · 内事领域" : "Branch · Internal Affairs"}
              items={sbd.internal}
            />
          )}
        </div>
      )}
    </div>
  );
}

export default LayerAnalysis;
